(function(){
  var root = document.getElementById('upass-skl');
  if (!root) return;
  var $ = function(id){ return document.getElementById(id); };
  var CFG = window.UPL_CFG;
  var MANAGED = [];
  /* CFG carries pack objects plus scalar options (defaultPack); only packs
     have a variant and belong in the managed-zeroing list. */
  Object.keys(CFG).forEach(function(k){
    var p = CFG[k];
    if (!p || typeof p !== 'object' || !p.variant) return;
    MANAGED.push(p.variant);
    if (p.heat) MANAGED.push(p.heat.variant);
  });
  var touched = false;
  var state = { pack:"p1", qty:1, heat:false };
  function money(cents){ return "$" + (cents/100).toFixed(2); }
  function cur(){ return CFG[state.pack]; }
  function unit(){ var p = cur(); return (state.heat && p.heat) ? p.heat.price : p.price; }
  function variantId(){ var p = cur(); return (state.heat && p.heat) ? p.heat.variant : p.variant; }

  function selectPack(k){
    state.pack = k; state.heat = false;
    root.querySelectorAll('.upl-pack').forEach(function(el){
      var on = el.getAttribute('data-pack') === k;
      el.classList.toggle('upl-sel', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var p = CFG[k];
    $('uplAddBtn').childNodes[0].textContent = 'Get my ' + p.nm + ' · ';
    $('uplAddPrice').textContent = money(p.price);
    $('uplAddSub').textContent = (p.save ? 'You save ' + money(p.save) + ' · ' : '') + (p.free ? 'FREE shipping' : 'plus shipping · ships same business day');
    $('uplStNm').textContent = p.nm + (p.flag ? ' · ' + p.flag : '');
    $('uplStPr').textContent = money(p.price);
    $('uplStMeta').textContent = '· ' + money(p.per) + ' per kit' + (p.free ? ' · FREE shipping' : ' · plus shipping');
    $('uplStGo').textContent = 'Get my ' + p.nm;
    $('uplSwitch2').hidden = (k !== 'p1');
    sync();
  }
  function sync(){
    var p = cur();
    $('uplLiImg').src = p.img;
    $('uplLiNm').textContent = 'Upass ' + p.nm + (state.heat && p.heat ? ' + Hot Sacks warmers' : '');
    $('uplLiMeta').textContent = money(p.per) + ' per kit' + (state.heat && p.heat ? ' · warmers included' : '');
    $('uplQtyN').textContent = state.qty;
    var sub = unit() * state.qty;
    $('uplLiPr').textContent = money(sub);
    $('uplSub').textContent = money(sub + extrasTotal());
    $('uplGrand').textContent = money(sub + extrasTotal());
    $('uplShipV').textContent = p.free ? 'FREE' : 'at checkout';
    $('uplShipV').className = p.free ? 'upl-fr' : '';
    $('uplFree').textContent = p.free ? 'FREE SHIPPING APPLIED' : 'PICK A PACK FOR FREE SHIPPING';
    $('uplFree').style.color = p.free ? '' : '#a30000';
    var sl = $('uplSaved');
    if (p.save){ sl.hidden = false; sl.textContent = 'You are saving ' + money(p.save * state.qty) + ' vs buying singles'; }
    else { sl.hidden = true; }
    var up = $('uplUpsell');
    if (state.pack === 'p3'){ up.hidden = true; }
    else {
      up.hidden = false;
      var tgtKey = state.pack === 'p1' ? 'p2' : 'p3';
      var t = CFG[tgtKey];
      $('uplUpT').textContent = 'Make it a ' + t.nm + ' for ' + money(t.price - p.price) + ' more';
      $('uplUpS').textContent = tgtKey === 'p2'
        ? 'FREE shipping, a backup kit, and ' + money(t.per) + ' per kit. Most customers do this.'
        : 'Drops you to ' + money(t.per) + ' per kit. Best value we sell.';
    }
    var heat = $('uplHeat');
    if (p.heat){
      heat.hidden = false;
      heat.classList.toggle('upl-on', state.heat);
      $('uplHeatBtn').textContent = state.heat ? 'Added ✓' : 'Add';
      $('uplHeatPr').textContent = '+' + money(p.heat.price - p.price);
      $('uplHeatS').textContent = p.heat.label;
    } else { heat.hidden = true; }
    if (root.classList.contains('upl-cart-open')) queueSync();
  }
  function movePromise(intoBag){
    var pr = root.querySelector('.delivery-promise__promise-container');
    var home = $('uplPromiseHome'), slot = $('uplPromiseSlot');
    if (pr && home && slot) (intoBag ? slot : home).appendChild(pr);
  }
  /* The theme's hidden cart drawer carries Shopify's express-wallet block
     (Shop Pay / Amazon Pay / PayPal, Apple Pay on Safari). There can only be
     one instance per page, so the bag adopts the node while it is open and
     returns it to the exact spot it came from on close. */
  var expressHome = null;
  function moveExpress(intoBag){
    var ex = document.querySelector('.cart-form__additional-checkout-buttons');
    var co = $('uplCheckout');
    if (!ex || !co) return;
    if (intoBag){
      if (!expressHome) expressHome = { parent: ex.parentNode, next: ex.nextSibling };
      var slot = $('uplExpressSlot');
      if (!slot){
        slot = document.createElement('div');
        slot.id = 'uplExpressSlot';
        var div = document.createElement('div');
        div.className = 'upl-exdiv';
        div.innerHTML = '<span>or express checkout</span>';
        slot.appendChild(div);
        co.parentNode.insertBefore(slot, co.nextSibling);
      }
      slot.classList.add('upl-exwait');
      slot.appendChild(ex);
      watchExpress();
    } else if (expressHome && expressHome.parent){
      if (expressHome.next && expressHome.next.parentNode === expressHome.parent) expressHome.parent.insertBefore(ex, expressHome.next);
      else expressHome.parent.appendChild(ex);
      ex.style.maxHeight = '';
      ex.style.overflow = '';
    }
  }
  /* Wallet presentation: show the first three wallet buttons and keep the
     rest behind a "More payment options" reveal. Only the plain wrapper div
     is measured and cropped (max-height + overflow hidden); Shopify's
     component and buttons are never styled, hidden, or reordered, so their
     internal layout and payment state stay untouched. Device wallets are
     injected after hydration, so a childList observer plus a delayed
     re-measure keep the crop honest. */
  var expressExpanded = false, expressObserver = null, expressResize = null, exMeasureT = null;
  function clipExpress(){
    var slot = $('uplExpressSlot');
    var wrap = slot ? slot.querySelector('.cart-form__additional-checkout-buttons') : null;
    var comp = wrap ? wrap.querySelector('shopify-accelerated-checkout-cart') : null;
    var more = $('uplExMore');
    if (!slot || !wrap || !comp){
      if (wrap){ wrap.style.maxHeight = ''; wrap.style.overflow = ''; }
      if (more) more.hidden = true;
      return;
    }
    var btns = [].slice.call(comp.children).filter(function(el){ return el.getBoundingClientRect().height > 8; });
    var cut = 0;
    if (btns.length > 3 && !expressExpanded){
      cut = Math.ceil(btns[2].getBoundingClientRect().bottom - wrap.getBoundingClientRect().top);
    }
    /* Crop only on a plainly real measurement: three full-size buttons never
       fit under 120px, and pre-hydration skeletons measure short. Anything
       else falls open to the full stack. */
    if (cut >= 120 && btns[0].getBoundingClientRect().height >= 30){
      wrap.style.maxHeight = cut + 'px';
      wrap.style.overflow = 'hidden';
      if (!more){
        more = document.createElement('button');
        more.type = 'button';
        more.id = 'uplExMore';
        more.textContent = 'More payment options ▾';
        more.addEventListener('click', function(){ expressExpanded = true; clipExpress(); });
        slot.appendChild(more);
      }
      more.hidden = false;
    } else {
      wrap.style.maxHeight = '';
      wrap.style.overflow = '';
      if (more) more.hidden = true;
    }
  }
  function watchExpress(){
    var slot = $('uplExpressSlot');
    var comp = slot ? slot.querySelector('shopify-accelerated-checkout-cart') : null;
    if (expressObserver){ expressObserver.disconnect(); expressObserver = null; }
    if (expressResize){ expressResize.disconnect(); expressResize = null; }
    if (comp && window.MutationObserver){
      expressObserver = new MutationObserver(clipExpress);
      expressObserver.observe(comp, { childList: true, subtree: true });
    }
    /* Buttons hydrate to full height without childList mutations; only the
       component is observed and only the wrapper is cropped, so the crop
       never feeds back into this observer. */
    if (comp && window.ResizeObserver){
      expressResize = new ResizeObserver(clipExpress);
      expressResize.observe(comp);
    }
    clipExpress();
    clearTimeout(exMeasureT);
    exMeasureT = setTimeout(clipExpress, 600);
  }
  /* Apple Pay builds its payment sheet from the wallet block's rendered state,
     so a block left as page load rendered it (empty cart) aborts the sheet
     with "an error occurred". After every cart write, re-render the block
     server-side with the real cart, the same Section Rendering API path the
     theme's own drawer uses, and swap it in place. Wallet taps stay disabled
     until the first fresh render lands. */
  function refreshExpress(){
    var done = function(){ var sl = $('uplExpressSlot'); if (sl) sl.classList.remove('upl-exwait'); };
    var render = function(){
      return fetch('/?sections=cart-footer')
        .then(function(r){ return r.json(); })
        .then(function(j){
          var html = j && j['cart-footer'];
          if (!html) return;
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var fresh = tpl.querySelector('.cart-form__additional-checkout-buttons');
          var cur = document.querySelector('.cart-form__additional-checkout-buttons');
          if (fresh && cur && cur.parentNode) cur.parentNode.replaceChild(fresh, cur);
          watchExpress();
        });
    };
    return render().catch(function(){
      return new Promise(function(res){ setTimeout(res, 1200); }).then(render);
    }).then(done).catch(done);
  }
  function openCart(){ root.classList.add('upl-cart-open'); sync(); movePromise(true); moveExpress(true); flushSync().catch(function(){}).then(function(){ refreshExpress(); }); fetch('/cart.js').then(function(r){ return r.json(); }).then(setExtras).catch(function(){}); var b = root.querySelector('.upl-drbody'); if (b) b.scrollTop = 0; }
  function closeCart(){ root.classList.remove('upl-cart-open'); movePromise(false); moveExpress(false); }
  var toastT;
  function toast(msg){
    var t = $('uplToast'); t.textContent = msg; t.classList.add('upl-show');
    clearTimeout(toastT); toastT = setTimeout(function(){ t.classList.remove('upl-show'); }, 3000);
  }
  /* The bag manages one line, but the real cart can hold other products
     (added from product pages, or older kit listings this page does not
     manage). Those lines are never touched by the managed write, so the bag
     must show them and count them, or its total lies and checkout charges
     more than the drawer promised. */
  var extras = [];
  function extrasTotal(){
    var t = 0;
    extras.forEach(function(e){ t += e.price; });
    return t;
  }
  function setExtras(cart){
    extras = [];
    if (cart && cart.items){
      cart.items.forEach(function(it){
        if (MANAGED.indexOf(it.variant_id) === -1){
          extras.push({
            id: it.variant_id,
            title: it.product_title,
            qty: it.quantity,
            price: (it.final_line_price != null ? it.final_line_price : it.line_price) || 0,
            img: it.image
          });
        }
      });
    }
    renderExtras();
    sync();
  }
  function renderExtras(){
    var li = root.querySelector('.upl-drbody .upl-li');
    var box = $('uplExtras');
    if (!extras.length){ if (box) box.parentNode.removeChild(box); return; }
    if (!li) return;
    if (!box){
      box = document.createElement('div');
      box.id = 'uplExtras';
      li.parentNode.insertBefore(box, li.nextSibling);
      box.addEventListener('click', function(e){
        var b = e.target.closest ? e.target.closest('[data-rm]') : null;
        if (b) removeExtra(parseInt(b.getAttribute('data-rm'), 10));
      });
    }
    var html = '<div class="upl-exh">Also in your bag</div>';
    extras.forEach(function(e){
      html += '<div class="upl-extra">'
        + (e.img ? '<img src="' + e.img + '" alt="" loading="lazy">' : '<span class="upl-exnoimg"></span>')
        + '<div class="upl-exi"><div class="upl-n"></div><div class="upl-m">Qty ' + e.qty + '</div></div>'
        + '<div class="upl-p">' + money(e.price) + '</div>'
        + '<button type="button" data-rm="' + e.id + '" aria-label="Remove from bag">&times;</button>'
        + '</div>';
    });
    box.innerHTML = html;
    var names = box.querySelectorAll('.upl-n');
    extras.forEach(function(e, i){ if (names[i]) names[i].textContent = e.title; });
  }
  function removeExtra(id){
    var updates = {};
    updates[id] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function(r){ return r.json(); }).then(function(c){
      setExtras(c);
      if (root.classList.contains('upl-cart-open')) refreshExpress();
    }).catch(function(){});
  }
  /* The bag writes to the real Shopify cart: whatever the drawer shows is what
     /cart holds, so the theme's cart icon, the cart page, and abandoned-cart
     emails all see the selection. One line item is managed; every write sets
     the current selection and zeroes every other managed variant, so no
     sequence of visits or switches can leave duplicate lines. */
  var committedVariant = null, committedQty = 0;
  var syncTimer = null, syncChain = Promise.resolve();
  function pushCart(){
    var v = variantId(), q = state.qty;
    if (committedVariant === v && committedQty === q) return Promise.resolve();
    var updates = {};
    MANAGED.forEach(function(mv){ updates[mv] = 0; });
    updates[v] = q;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function(r){
      if (!r.ok){ var e = new Error('cart update failed'); e.status = r.status; throw e; }
      committedVariant = v; committedQty = q;
      if (root.classList.contains('upl-cart-open')) refreshExpress();
      r.json().then(setExtras).catch(function(){});
    });
  }
  function queueSync(){
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function(){
      syncChain = syncChain.then(pushCart).catch(function(){});
    }, 350);
  }
  function flushSync(){
    clearTimeout(syncTimer);
    var run = syncChain.then(pushCart);
    syncChain = run.catch(function(){});
    return run;
  }
  function resetCartSession(){
    var d = '.' + location.hostname.split('.').slice(-2).join('.');
    ['cart', 'cart_sig'].forEach(function(n){
      document.cookie = n + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      document.cookie = n + '=; path=/; domain=' + d + '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
    committedVariant = null; committedQty = 0;
    syncChain = Promise.resolve();
  }
  function addThenGo(dest){
    var btn = $('uplCheckout');
    var prev = btn.textContent;
    btn.disabled = true; btn.innerHTML = '<span class="upl-spin"></span>Adding...';
    flushSync().catch(function(err){
      if (!(err && err.status)) throw err;
      resetCartSession();
      return pushCart();
    }).then(function(){
      btn.innerHTML = '<span class="upl-spin"></span>One moment...';
      window.location.href = dest;
      setTimeout(function(){
        btn.disabled = false; btn.textContent = prev;
        toast('Checkout is taking a moment to load. Your kit is saved in the cart, tap again to continue.');
      }, 10000);
    }).catch(function(){
      btn.disabled = false; btn.textContent = prev;
      toast('Something went wrong. Please try again.');
    });
  }
  /* A completed checkout consumes the cart server-side, but the browser's
     back-forward cache restores this page with its old JS state: the bag
     still shows the old selection while the real cart is empty, so wallet
     sheets build from a $0.00 cart. On every bfcache restore, forget what
     was committed; if the bag is open, rewrite the cart and re-render the
     wallet block, gating wallet taps until the fresh block lands. */
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    committedVariant = null; committedQty = 0;
    syncChain = Promise.resolve();
    if (root.classList.contains('upl-cart-open')){
      var sl = $('uplExpressSlot');
      if (sl) sl.classList.add('upl-exwait');
      flushSync().catch(function(){}).then(function(){ refreshExpress(); });
    }
  });

  root.querySelectorAll('.upl-pack').forEach(function(el){
    el.addEventListener('click', function(){ selectPack(el.getAttribute('data-pack')); });
  });
  /* The section markup is shared by more than one template and optional blocks
     (e.g. the savings-math CTAs) may be absent, so every binding is guarded:
     one missing element must not abort the wiring of everything after it. */
  function on(id, fn){ var el = $(id); if (el) el.addEventListener('click', fn); }
  on('uplAddBtn', openCart);
  on('uplSwitch2', function(){ selectPack('p2'); openCart(); toast('Switched to the 2-Pack. FREE shipping applied.'); });
  on('uplStGo', openCart);
  on('uplCtaP2', function(){ selectPack('p2'); openCart(); });
  on('uplCtaP3', function(){ selectPack('p3'); openCart(); });
  on('uplDrx', closeCart);
  on('uplScrim', closeCart);
  on('uplQtyDn', function(){ state.qty = Math.max(1, state.qty - 1); sync(); });
  on('uplQtyUp', function(){ state.qty = Math.min(9, state.qty + 1); sync(); });
  on('uplHeatBtn', function(){ state.heat = !state.heat; sync(); });
  on('uplUpBtn', function(){
    var tgt = state.pack === 'p1' ? 'p2' : 'p3';
    selectPack(tgt); toast('Upgraded to the ' + CFG[tgt].nm + '.');
  });
  on('uplCheckout', function(){ addThenGo('/checkout'); });
  on('uplViewBag', function(){ addThenGo('/cart'); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });

  function cutoffTick(){
    try{
      var now = new Date();
      var pt = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
      var day = pt.getDay();
      var cut = new Date(pt); cut.setHours(15,0,0,0);
      var chip = $('uplCutoff'), shipH = $('uplShipH2');
      if (day >= 1 && day <= 5 && pt < cut){
        var ms = cut - pt;
        var h = Math.floor(ms/3600000), m = Math.floor(ms%3600000/60000);
        chip.innerHTML = 'Order within <b>' + h + 'h ' + (m<10?'0':'') + m + 'm</b> and it ships today';
        if (shipH) shipH.textContent = 'Order by 3 PM PT, it ships today.';
      } else {
        chip.textContent = 'In stock · order by 3 PM PT Mon-Fri, ships same day';
        if (shipH) shipH.textContent = 'Order by 3 PM PT Mon-Fri, it ships same day.';
      }
    }catch(e){}
  }
  cutoffTick(); setInterval(cutoffTick, 30000);

  selectPack((CFG.defaultPack && CFG[CFG.defaultPack]) ? CFG.defaultPack : 'p1');

  /* A returning visitor may already have one of our kits in the cart from an
     earlier visit. Adopt it: reflect that pack/quantity in the page instead of
     silently starting a second line. Read-only; nothing is written until the
     visitor interacts. */
  root.addEventListener('click', function(){ touched = true; }, { capture: true, once: true });
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
    if (!c || !c.items) return;
    setExtras(c);
    if (touched) return;
    for (var i = 0; i < c.items.length; i++){
      var it = c.items[i];
      for (var k in CFG){
        var p = CFG[k];
        if (!p || typeof p !== 'object' || !p.variant) continue;
        var isHeat = !!(p.heat && p.heat.variant === it.variant_id);
        /* v4.14: a page whose default is the 2-Pack or 3-Pack keeps its own
           product selected; a different kit already in the cart is shown in
           the bag ("Also in your bag") instead of hijacking the picker. */
        if (CFG.defaultPack && CFG.defaultPack !== 'p1' && k !== CFG.defaultPack) continue;
        if (p.variant === it.variant_id || isHeat){
          if (touched) return;
          selectPack(k);
          state.heat = isHeat;
          state.qty = Math.max(1, Math.min(9, it.quantity));
          committedVariant = it.variant_id; committedQty = it.quantity;
          sync();
          return;
        }
      }
    }
  }).catch(function(){});
})();
